export const numberFormat = new Intl.NumberFormat("no-NB", {
  maximumFractionDigits: 2
});

export const currencyFormat = new Intl.NumberFormat("no-NB", {
  maximumFractionDigits: 2,
  style: "currency",
  currency: "NOK"
});
